import { useRef } from "react";

import Modal from "../../backoffice/components/Modal";
import { capitalizeFirstLetter } from "../../utils/letters";
import { formatDate } from "../../utils/date";

function isMicrosoftSharingUrl(value) {
	try {
		const url = new URL(value);
		const host = url.hostname.toLowerCase();
		return (
			host.endsWith(".sharepoint.com") ||
			host.endsWith(".sharepointonline.com") ||
			host.endsWith(".office.com") ||
			host.endsWith(".microsoft.com") ||
			host.endsWith(".microsoft365.com") ||
			host.endsWith(".cloud.microsoft") ||
			host.endsWith(".onedrive.live.com")
		);
	} catch {
		return false;
	}
}

function canAttemptEmbed(value) {
	if (!value) return false;
	if (!isMicrosoftSharingUrl(value)) return true;

	const lowerValue = value.toLowerCase();
	return (
		lowerValue.includes("/embed") ||
		lowerValue.includes("embed.aspx") ||
		lowerValue.includes("action=embedview")
	);
}

export default function RecordingPlayerModal({ recording, onClose }) {
	const playerRef = useRef(null);

	if (!recording) return null;

	function handleFullscreen() {
		const target = playerRef.current;
		if (!target) return;

		if (target.requestFullscreen) {
			target.requestFullscreen();
		} else if (target.webkitRequestFullscreen) {
			target.webkitRequestFullscreen();
		}
	}

	function handleOpenExternal() {
		if (!recording.recording_url) return;
		window.open(recording.recording_url, "_blank", "noopener,noreferrer");
	}

	const title = capitalizeFirstLetter(recording.title || "Grabación");
	const sessionDate = recording.session_date
		? formatDate(recording.session_date)
		: null;
	const shouldEmbed = canAttemptEmbed(recording.recording_url);

	return (
		<Modal
			title={title}
			open={Boolean(recording)}
			onClose={onClose}
			dialogClassName="modal-dialog modal-dialog-centered modal-lg recording-player-dialog"
			footer={
				<>
					{shouldEmbed ? (
						<button
							type="button"
							className="btn adm-see-btn"
							onClick={handleFullscreen}
						>
							<i className="ri-fullscreen-line" aria-hidden />
							<span>Pantalla completa</span>
						</button>
					) : null}
					<button
						type="button"
						className="btn adm-save-btn recording-player-open-btn"
						onClick={handleOpenExternal}
					>
						<i className="ri-external-link-line" aria-hidden />
						<span>Abrir grabación en Microsoft</span>
					</button>
					<button type="button" className="btn adm-del-btn" onClick={onClose}>
						<span>Cerrar</span>
					</button>
				</>
			}
		>
			<div className="recording-player-modal font-n">
				{sessionDate && (
					<p className="recording-player-date mb-2">
						<span>{sessionDate}</span>
					</p>
				)}
				{shouldEmbed ? (
					<div ref={playerRef} className="recording-player-frame-shell">
						<iframe
							className="recording-player-frame"
							src={recording.recording_url}
							title={title}
							allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
							allowFullScreen
						/>
					</div>
				) : (
					<div className="recording-player-external-panel">
						<i className="ri-microsoft-fill" aria-hidden />
						<div>
							<h6>Reproducción protegida por Microsoft</h6>
							<p>
								Esta grabación debe abrirse en Microsoft con los permisos
								asignados por el administrador del curso.
							</p>
						</div>
					</div>
				)}
				{recording.notes && (
					<p className="recording-player-notes mt-3 mb-0">
						<span>{capitalizeFirstLetter(recording.notes)}</span>
					</p>
				)}
			</div>
		</Modal>
	);
}
